import React from 'react'
import { Layer, Source } from 'react-mapbox-gl'
import { DrawControl } from '@leverege/ui-mapbox-elements'

import * as turf from '@turf/turf'

import DrawModes from './drawModes'
import ConnectedDrawControl from './ConnectedDrawControl'
import Utils from '../../utils/Geotile'

class ImagePlacementController {

  constructor( options ) {
    this.options = options
    this.getFeature = options.getFeature
    this.onReposition = key => setTimeout( () => options.onReposition( key ), 200 )
    this.updateFeature = options.updateFeature
    this.url = ''
    this.drawControlRef = React.createRef()
    this.mapSource = options.mapSource
    this.sourceKey = ''
    this.imageFileName = ''
    this.featureId = ''
    this.image = new Image()
    this.imageData = {}
    this.image.onload = () => {
      this.imageData = {
        image : this.image,
        height : this.image.height,
        width : this.image.width
      }
    }
  }

  setUrl = ( url, imageFileName ) => {
    this.url = url
    this.imageFileName = imageFileName
    this.image.src = url
    this.onReposition( this.sourceKey + imageFileName )
  }

  onDrawCreate = ( e ) => {
    if ( this.featureId !== e.features[0].id ) {
      this.featureId = e.features[0].id
      this.onReposition( this.sourceKey + this.imageFileName )
    }
    this.updateFeature( e.features[0] )
  }

  onDrawUpdate = ( e, opts ) => {
    const feature = e?.features ? e.features[0] : e
    const pts = feature?.features?.[0]?.geometry?.coordinates || feature?.geometry?.coordinates
    if ( pts ) {
      const r = pts[0].map( ( p ) => { return [ p[0], p[1] ] } )
      // this.drawControlRef.current.setState( { lngLat : r } )
      this.sourceKey = Utils.makeHash( r )
    }
    this.updateFeature( feature )
    this.onReposition( this.sourceKey + this.imageFileName )
  }

  getImage = () => this.imageData

  onTrash = ( cleanup, cb ) => {
    const drawControl = this.drawControlRef.current
    drawControl.onTrash()
    this.sourceKey = `${Date.now()}`
    this.updateFeature( null )
    this.onReposition( `${this.sourceKey}${Date.now()}` )
    if ( !cleanup ) {
      // kick trash to give it a chance to update the image layer + geoshape
      setTimeout( () => this.onTrash( true, cb ), 100 )
    } else if ( cb ) {
      cb()
    }
  }

  getCoordinates = () => {
    const feature = this.getFeature()
    const coordArr = feature?.geometry?.coordinates
    if ( coordArr ) {
      return coordArr[0]
    }
    return null
  }

  render() {
    return null
  }

  getLayers( geotile, imageHash ) {
    // imageHash='1'
    // console.log( 'imageHash =', imageHash )
    const { editor : { imageLayerOpacity } } = geotile
    const { onSourceAdded, onSourceLoaded, id, before } = this.options
    const { featureId, sourceKey, url } = this
    const coordinates = this.getCoordinates()
    const layers = []
    if ( url && coordinates && imageLayerOpacity ) {
      const srcId = `${featureId}-${sourceKey}-${this.imageFileName}-${imageHash}`
      const obj = {
        type : 'image',
        url,
        coordinates : coordinates.slice( 0, 4 )
      }

      layers.push(
        <Source
          id={srcId}
          geoJsonSource={obj}
          key={srcId}
          onSourceAdded={onSourceAdded}
          onSourceLoaded={onSourceLoaded} />,

        <Layer
          id={`${srcId}-raster`}
          sourceId={srcId}
          type="raster"
          key={`${srcId}-raster`}
          paint={{
            'raster-opacity' : imageLayerOpacity,
            'raster-fade-duration' : 0
          }}
          before={before} />
      )
    }

    layers.push(
      <ConnectedDrawControl
        mapName="map"
        sourceId={id}
        mapSource={this.mapSource}
        drawControlRef={this.drawControlRef}
        onDrawCreate={this.onDrawCreate}
        onDrawUpdate={this.onDrawUpdate}
        getImage={this.getImage}
        select={`${id}-feature`}
        key={`${id}-drawcontrol`}
        id={`${id}-drawcontrol`}
        before={`${id}-raster`} />
    )
    return layers
  }
}

module.exports = ImagePlacementController
